<template>
    <v-app>
        <Toolbar title="Device Orders for Group"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/group/' + groupId})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ groupData['name'] }}</div>
                                <span class="grey--text">ID: {{ groupId }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12 md10 offset-md1>
                    <v-toolbar color="blue darken-2" dark>
                        <v-toolbar-title>Start New Device Order</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card>
                        <v-card-title>
                            <v-text-field
                                    v-model="newOrderName"
                                    label="Enter Merchant Business Name"
                                    single-line
                                    hide-details
                            ></v-text-field>
                            <v-btn color="default" @click="addNewOrder">Create New Order</v-btn>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
<v-divider></v-divider>
            <v-card>
                <v-card-title primary-title>
                    <h3 class="headline mb-0">Orders</h3>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>

                <v-data-table
                        :pagination.sync="pagination"
                        :headers="orderHeaders"
                        :items="ordersForGroup"
                        :search="search"
                >
                    <template slot="items" slot-scope="props">
                        <td class="subheading">{{ dateFrom(props.item.updatedAt) }}</td>
                        <td class="subheading" @click="routeLink(props.item.id)" v-if="props.item.status === 'draft'">{{
                            props.item.business }}
                            <v-icon>edit</v-icon>
                        </td>
                        <td class="subheading" v-else>{{ props.item.business }}</td>
                        <td class="subheading" v-if="props.item.status === 'ship'">Processing</td>
                        <td class="subheading" v-else>{{ upperCaseFirst(props.item.status) }}</td>
                        <td class="subheading">{{ props.item.merchantId }}</td>
                        <td class="subheading">{{ props.item.terminalId }}</td>
                        <td class="subheading">
                            <DeviceType v-bind:device-type="props.item.deviceType"/>
                        </td>
                        <td class="subheading">{{ props.item.reference }}</td>
                        <td class="subheading">{{ props.item.shippingReference }}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>

            </v-card>

        </v-content>
    </v-app>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import DeviceType from '../components/DeviceType'
    import Moment from 'moment'

    const fb = require('../firebase')

    export default {
        name: "Orders",
        components: {Toolbar, DeviceType},
        data() {
            return {
                search: '',
                pagination: {'sortBy': 'updatedAt', 'descending': true, 'rowsPerPage': 50},
                rowsPerPage: [25, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                orderHeaders: [
                    {text: 'Updated', align: 'left', sortable: true, value: 'updatedAt'},
                    {text: 'Business', align: 'left', sortable: true, value: 'business'},
                    {text: 'Status', align: 'left', sortable: true, value: 'status'},
                    {text: 'Merchant ID', align: 'left', sortable: true, value: 'merchantId'},
                    {text: 'Terminal ID', align: 'left', sortable: true, value: 'terminalId'},
                    {text: 'Device', align: 'left', sortable: true, value: 'deviceType'},
                    {text: 'Reference', align: 'left', sortable: true, value: 'reference'},
                    {text: 'Shipping', align: 'left', sortable: true, value: 'shippingReference'}
                ],
                ordersForGroup: [],
                newOrderName: ''
            }
        },
        mounted() {
            // console.log(this.groupId)

            if (!this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
            }
            if (this.groupId === undefined || this.groupId === 'undefined') {
                this.$router.push({path: '/groups'})
            }
            this.fetchAll()
            this.fetchOrdersForGroup(this.groupId)
        },
        computed: {
            ...mapGetters(['getActiveNewOrderId']),
            groupId: function () {
                return this.$route.params.group_id
            },
            groupData: function () {
                let gd = this.$store.state.groups[this.groupId]
                if (gd === undefined) {
                    return {}
                }
                return gd
            }
        },
        watch: {
            getActiveNewOrderId: function (val) {
                if (val !== '') {
                    this.$router.push({path: '/order/' + this.groupId + '/' + val})
                    this.$store.state.activeNewOrderId = ''
                }
            },
        },
        methods: {
            ...mapActions(['isUserLoggedIn', 'fetchAll', 'addNewOrderToGroup']),
            routeLink: function (val) {
                this.$router.push('/order/' + this.groupId + '/' + val)
            },
            dateFrom: function (dt) {
                return Moment.unix(dt).fromNow()
            },
            upperCaseFirst: function (val) {
                return val.charAt(0).toUpperCase() + val.substr(1)
            },
            fetchOrdersForGroup: function (groupId) {
                this.$store.commit('showProgress')
                let that = this

                fb.formsCollection
                    .where('group', '==', groupId)
                    .get()
                    .then(function (forms) {
                        that.$store.commit('hideProgress')
                        that.ordersForGroup = []
                        forms.forEach((form) => {
                            let f = form.data()
                            if (f['updatedAt'] === undefined) {
                                f['updatedAt'] = Math.floor(Date.now() / 1000)
                            } else {
                                f['updatedAt'] = Math.floor(f['updatedAt'].seconds)
                            }
                            f['id'] = form.id
                            that.ordersForGroup.push(f)
                        })
                    })

            },
            addNewOrder: function () {
                if (this.newOrderName !== '') {
                    this.addNewOrderToGroup([this.groupId, this.newOrderName])
                }
            }
        }
    }
</script>

<style scoped>

</style>
